import { observable, makeObservable } from 'mobx';

export default class Grid33_33_33 {

  id = null;
  type = null;
  leftSide = null;
  middle = null;
  rightSide = null;
  additionalPaddingBelowComponent = null;

  constructor(props) {
    makeObservable(this, {
      id: observable,
      type: observable,
      leftSide: observable,
      middle: observable,
      rightSide: observable,
      additionalPaddingBelowComponent: observable
    });

    this.id = props.id
    this.type = props.type
    this.leftSide = props.leftSide
    this.middle = props.middle
    this.rightSide = props.rightSide
    this.additionalPaddingBelowComponent = props.additionalPaddingBelowComponent
  }
}